import mitt from 'mitt'

// BEEP BEEP
const BUS = mitt()

export function subscribe (evt, cb) {
  BUS.off(evt)
  BUS.on(evt, cb)
  return () => BUS.off(evt, cb)
}

export function dispatch (evt, params) {
  return BUS.emit(evt, params)
}

export default { subscribe, dispatch }

// // Search for buttons across the page that are set to
// // trigger an event dispatch.
// document.querySelectorAll('[data-event-dispatch]').forEach(el => {
//   const elAttrs = el.attributes
//   const eventName = elAttrs['data-event-dispatch'].value
//   const eventData = JSON.parse(elAttrs['data-event-data'].value)
//   const eventOn = elAttrs['data-event-on']?.value || 'click'
//   el.addEventListener(eventOn, () =>{
//     dispatch(eventName, eventData)
//   })
// })
